/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAlert from '../../hooks/useAlert';
import { onClickEvent } from '../../lib/gaAnalytics';
import { DataShimmer, Helpfull, Shimmer } from '../common';
import FaqTicketCreate from '../common/FaqTicketCreate';
import styles from '../../styles/Accordion.module.scss';
import styles2 from './TrackCompetitors.module.scss';
import {
  CreateTicket,
  getCompanyDetails,
  GetFaqs,
  getRegisterFcm,
  getStatistics,
  handleImpressionsTrack,
} from '../../api';
import ContractHealth from './ContractHealth';
import {
  andriodSource,
  clickTracker,
  getContractTypeVal,
  getCookie,
  getProjectId,
  getSourceValue,
  getSubEventType,
  handleRedirection,
  helpfulObjData,
  iosSource,
} from '../../lib/common';
import { handleShowTagsFeedback } from '../../reducersAndActions/actions/appStateActions';
import { useAppState } from '../../contexts/appState';
import { useLocalStorage, useSessionStorage } from '../../hooks';
import NoDataView from '../../pages/NoDataView';
import { useAuth } from '../../contexts/auth';

const LeadsFaq = () => {
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [userDetails] = useSessionStorage('userDetails', '');
  const [loading, setLoading] = useState(true);
  const [faqData, setFaqData] = useState([]);
  const [faqResponse, setFaqResponse] = useState([]);
  const [showAns, setShowAns] = useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [setActive, setActiveState] = useState('');
  const [searchQuestion, setSearchQuestion] = useState('');
  const [updateAns, setUpdateAns] = useState('');
  const source = getSourceValue();
  const navigate = useNavigate();
  const [statisticsData, setStatisticsData] = useState({});
  const [statisticsLoading, setStatisticsLoading] = useState(false);
  const [setAlert] = useAlert();
  const [showMore, setShowMore] = useState(true);
  const [selectedFaqData, setSelectedFaqData] = useState({});
  const [helpful, setHelpful] = useState(helpfulObjData && helpfulObjData);
  const [apiResultType, setApiResultType] = useState('');
  const [faqsFeedbackData, setFaqsFeedbackData] = useState({});
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showData, setShowData] = useState(true);
  const projectId = getProjectId();
  const [, appDispatch] = useAppState();
  const contractVal = getContractTypeVal(projectId);
  const [authState] = useAuth();

  let searchQid = '';
  searchQid = localStorage.getItem('searchQid');

  useEffect(() => {
    const storedFeedbackData = sessionStorage.getItem('faqsFeedback');
    if (storedFeedbackData) {
      setFaqsFeedbackData(JSON.parse(sessionStorage.getItem('faqsFeedback')));
    }
  }, []);

  const healthCheckObj = [
    {
      id: 0,
      icon: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/leaderboard_icon.svg',
      title: 'Run a health check on your leads',
      alt: 'healthCheck-icon',
    },
    {
      id: 1,
      icon: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/healthcheck_icon.svg',
      title: 'View the leads leaderboard',
      alt: 'competiters-icon',
    },
  ];

  const handleFcmClick = async (e) => {
    if (document.getElementById('fcmClick')) {
      document.getElementById('fcmClick').style.color = '#2B6BEE';
      if (e.target.id === 'fcmClick') {
        try {
          const params = {};
          const res = await getRegisterFcm(params);
          if (res.errorCode === 0) {
            setAlert({
              message: res?.result || '',
              status: true,
            });
          }
        } catch (err) {
          console.log('error', err);
        }
      }
    } else if (document.getElementById('pincodeTicketCreate') && e.target.id === 'pincodeTicketCreate') {
      const paramsData = {
        vertical: 'LISTING',
        category: 'CS',
        ticket_creator: 'BUSINESS',
        nm: userDetails?.fullName || '',
        created_by: userDetails?.mobile || '',
        mob: userDetails?.mobile || '',
        issue_type: 'Data changes/validation request',
        issue_sub_type: 'Pincode addition/deletion',
        issue_comment: '',
        document: [],
        city: selectedBusiness?.data_city || '',
        oid: '',
        orderid: '',
        docid: selectedBusiness?.docid || '',
        src: 'business',
        src_typ: 'csportal',
        src_nm: userDetails?.fullName || '',
        src_mob: userDetails?.mobile || '',
      };
      const res = await CreateTicket(paramsData);
      setAlert({
        message: res?.errorCode === 0 ? res?.result?.msg || '' : res?.message || 'Something went wrong',
        status: res?.errorCode === 0,
      });
    }
  };

  const handleFaqClick = async (data, index) => {
    handleShowTagsFeedback(appDispatch, {});
    setShowData(true);
    setActiveIndex(index === activeIndex ? -1 : index);
    setHelpful(helpfulObjData && helpfulObjData);
    setSelectedFaqData(data);
    setSelectedQuestionId(selectedQuestionId === index ? null : index);
    setShowAns(selectedQuestionId !== index);
    setActiveState(setActive === '' || selectedQuestionId !== index ? `${styles.Active}` : ``);
    setApiResultType('');
    if (selectedQuestionId !== index) {
      // setIssueComment('');
      if (data?.type === 'APICALL') {
        try {
          setStatisticsLoading(true);
          const params = {
            pid: selectedBusiness?.parentid || '',
            city: selectedBusiness?.data_city || '',
            type: data?.apiKey || '',
            source,
            projectId: 'csportal',
          };
          const res = await getStatistics(params);
          if (res && res.errorCode === 0) {
            setStatisticsData(res?.result || {});
          }
          setStatisticsLoading(false);
        } catch (e) {
          console.log('error in getStatistics', e);
        }
      }

      if (data?.type === 'redirect') {
        try {
          const res = await getCompanyDetails(selectedBusiness?.docid || '');
          if (res && res.errorCode === 0) {
            if (res?.result === 'ANS') {
              setApiResultType(res?.result || '');
            } else if (res?.result === 'APICALL') {
              handleRedirection(source, data?.paramUrl || '', false);
            }
          }
        } catch (err) {
          console.log('error in getCompanyDetails', err);
        }
      }
      await clickTracker(getSubEventType[data?.id] || '', 'leads_FAQ');
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = `faq_${data?.faqKey}`;
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = 'issue_leads';
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    }

    const updatedAns = data?.ans?.replace(
      '<videoURL>',
      `<div style="display: flex;justify-content: center;margin-right:15px;margin-top:10px;"><iframe title="videoUrl" allowFullScreen src=https://www.youtube.com/embed/${data?.videoUrl}> </iframe></div>`,
    );
    setUpdateAns(updatedAns);

    if (data?.ans === 'APICALL') {
      navigate('/csportal/leads/contract_health');
    }
  };

  const handleSearchFaq = (e) => {
    setSelectedQuestionId(null);
    setSearchQuestion(e.target.value);
    const filteredFaqData =
      faqResponse && faqResponse.filter((each) => each.question.toLowerCase().includes(e.target.value.toLowerCase()));
    setFaqData(filteredFaqData);
  };

  const handleSearch = (paramsData) => {
    const data = paramsData;
    data?.forEach((ele, i) => {
      if (ele?.id?.toString() === searchQid) {
        data?.splice(i, 1);
        data?.unshift(ele);
      }
    });

    data?.forEach((faq, i) => {
      if (faq?.id?.toString() === searchQid) {
        handleFaqClick(faq, i);
      }
    });
    return data;
  };

  useEffect(() => {
    window.addEventListener('click', handleFcmClick);
    return () => {
      window.removeEventListener('click', handleFcmClick);
    };
  }, []);

  useEffect(() => {
    const handleGetFaqs = async () => {
      try {
        setLoading(true);
        const paramsData = {
          key: 'leads',
          docId: selectedBusiness.docid || '',
          parentId: selectedBusiness.parentid || '',
          mobile: userDetails?.mobile || '',
          compName: selectedBusiness.compname ? encodeURIComponent(selectedBusiness.compname) : '',
          area: selectedBusiness.areaname ? encodeURIComponent(selectedBusiness.areaname) : '',
          city: selectedBusiness.data_city ? encodeURIComponent(selectedBusiness.data_city) : '',
          source,
          sid: getCookie('sid') || '',
          shortUrl: selectedBusiness.shorturl || '',
        };
        const res = await GetFaqs(paramsData);
        if (res.errorCode === 0) {
          if (searchQid && searchQid !== '') {
            res.result = handleSearch(res.result);
          }
          setFaqData(res.result || []);
          setFaqResponse(res.result || []);
        }
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    };
    if (selectedBusiness?.docid) {
      handleGetFaqs();
    } else {
      setLoading(selectedBusiness?.docid || false);
    }
  }, []);

  const handleHealthCheck = async (id) => {
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_${id === 0 ? 'leadsdiagnosis' : 'leaderboard'}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_leads`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
    if (id === 1) {
      const url = `https://wap.justdial.com/analytics/competitortrend?docid=${
        selectedBusiness?.docid || ''
      }&m=1&source=${source}&hide_header=1&el=1`;
      if (andriodSource.includes(source) || iosSource.includes(source)) {
        window.open(url);
      } else {
        window.location = url;
      }
    } else {
      navigate('/csportal/leads/contract_health');
    }
    await clickTracker(
      id === 0 ? 'healthcheck_run' : 'competition_view',
      id === 0 ? 'leads_healthcheck' : 'leads_competition',
    );
  };

  const handleisHelpful = async (index, apiKey, faqId) => {
    setFaqsFeedbackData((prevData) => ({
      ...prevData,
      [faqId]: index === 0 ? 'Helpful' : 'NotHelpful',
    }));

    sessionStorage.setItem(
      'faqsFeedback',
      JSON.stringify({ ...faqsFeedbackData, [faqId]: index === 0 ? 'Helpful' : 'NotHelpful' }),
    );

    setHelpful((prevObj) =>
      prevObj.map((each) => (each.id === index ? { ...each, isActive: true } : { ...each, isActive: false })),
    );
    onClickEvent(
      `${`Leads-${apiKey}-${selectedBusiness?.docid}`}`,
      `${`Leads-${apiKey}-${selectedBusiness?.docid}`} ${helpful[index]?.val ? 'Helpful' : 'Not Helpful'}`,
      '',
    );

    await clickTracker(`${getSubEventType[faqId]}_${index === 0 ? 'yes' : 'no'}`, 'leads_FAQ_feedback');
  };

  const updatedFaqs = showMore ? (faqData && faqData.length > 0 ? faqData.slice(0, 4) : faqData) : faqData;

  const handleLeadsFaqAnsClick = async (e, faqObj) => {
    if (
      projectId === 'csportal' &&
      ['DownloadLeads', 'ManageCampainUrl', 'LeadsDashboard', 'Categories'].includes(e.target.id) &&
      ['DownloadLeads', 'UnableToConvertLeads', 'IncreaseDailyLeads', 'CannotAccessLeads'].includes(faqObj?.faqKey)
    ) {
      const liVal = 'click';
      const liTrd = `cta_clickhere`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_leads`;
      const llTrdInside = `faq_${selectedFaqData?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
  };

  return (
    <>
      <>
        <div className="p-20">
          {loading ? (
            <DataShimmer loading={loading} id="leadsfaq" />
          ) : (
            <>
              {contractVal && contractVal !== 'free' ? (
                <>
                  {' '}
                  <div className="font16 fw700 color111 mb-15">Hi, how can we help you with your leads today?</div>
                  <div className={`${styles.Accordion__Search}`}>
                    <input
                      className={`${styles.Accordion__Input} font12 fw500 color111`}
                      type="text"
                      placeholder="Search for keywords..."
                      value={searchQuestion}
                      onChange={handleSearchFaq}
                    />
                  </div>
                  <div className={`${styles.Accordion__Box}`}>
                    <div className="mt-10">
                      {loading ? (
                        <Shimmer loading={loading} id="faq" />
                      ) : (
                        <>
                          {updatedFaqs && updatedFaqs.length > 0 ? (
                            <>
                              {updatedFaqs &&
                                updatedFaqs.map((each, idx) => (
                                  <div key={idx}>
                                    <div
                                      aria-label="leads_faq_click"
                                      tabIndex={0}
                                      role="button"
                                      onKeyDown={() => {}}
                                      onClick={() => handleFaqClick(each, idx)}
                                      className={`${styles.Accordion__Pannel__Heading} ${
                                        selectedQuestionId === idx && showAns ? setActive : ''
                                      }`}
                                    >
                                      <div className={`${styles.Accordion__Pannel__Title} font13 fw500 color111`}>
                                        {each?.question || ''}
                                      </div>
                                      <div className={`${styles.Accordion__Pannel__Icon} csicon`} />
                                    </div>

                                    {(each?.type !== 'redirect' || apiResultType === 'ANS') && (
                                      <div className={`${styles.Accordion__Contant}`}>
                                        <div className={`${styles.Accordion__TextContant}`}>
                                          {showData ? (
                                            <>
                                              {each?.type !== 'APICALL' ? (
                                                <>
                                                  {each?.videoUrl && each?.videoUrl !== '' ? (
                                                    <div
                                                      className="font12 fw400 color777 p-10"
                                                      id="leads-faqs-list"
                                                      dangerouslySetInnerHTML={{ __html: updateAns }}
                                                      aria-label="leads_videoUrl_click"
                                                      tabIndex={0}
                                                      role="button"
                                                      onKeyDown={() => {}}
                                                      onClick={(e) => handleLeadsFaqAnsClick(e, each)}
                                                    />
                                                  ) : (
                                                    <div
                                                      className="font12 fw400 color777 p-10"
                                                      id="leads-faqs-ans"
                                                      dangerouslySetInnerHTML={{ __html: each?.ans }}
                                                      aria-label="leads_ans_click"
                                                      tabIndex={0}
                                                      role="button"
                                                      onKeyDown={() => {}}
                                                      onClick={(e) => handleLeadsFaqAnsClick(e, each)}
                                                    />
                                                  )}
                                                </>
                                              ) : each.type === 'APICALL' &&
                                                selectedQuestionId === idx &&
                                                statisticsData &&
                                                statisticsData?.healthCheck === 90 ? (
                                                statisticsLoading ? (
                                                  <>
                                                    <div className="loader-div">
                                                      <div
                                                        className="bt-spinner"
                                                        style={{ height: '25px', width: '25px' }}
                                                      />
                                                    </div>
                                                  </>
                                                ) : (
                                                  <div
                                                    className={`${styles.Accordion__ListItem} font12 fw400 color777 p-10`}
                                                    dangerouslySetInnerHTML={{ __html: each?.ans }}
                                                  />
                                                )
                                              ) : (
                                                selectedQuestionId === idx &&
                                                statisticsData &&
                                                statisticsData?.healthCheck !== 90 && (
                                                  <ContractHealth
                                                    id="faq"
                                                    statisticsData={statisticsData}
                                                    statisticsLoading={statisticsLoading}
                                                    apiKey={each?.apiKey || ''}
                                                    selectedFaqData={selectedFaqData}
                                                    faqId={each?.id || null}
                                                  />
                                                )
                                              )}
                                              {(!statisticsLoading || apiResultType === 'ANS') && (
                                                <>
                                                  <div className={`${styles.Accordion__Helpful} mt-20 mb-10`}>
                                                    <div className="font11 fw400 color777 mr-10">Was this Helpful?</div>
                                                    {helpful &&
                                                      helpful.map((item) => (
                                                        // eslint-disable-next-line jsx-a11y/control-has-associated-label
                                                        <div
                                                          key={item.id}
                                                          aria-label="leads_helpful"
                                                          tabIndex={0}
                                                          role="button"
                                                          onKeyDown={() => {}}
                                                          onClick={() => {
                                                            handleisHelpful(item.id, each.apiKey, each.id);
                                                            setShowData(item.id === 0);
                                                            if (item.id === 1 && projectId === 'csportal') {
                                                              handleShowTagsFeedback(appDispatch, {
                                                                status: true,
                                                                question: each?.question || '',
                                                              });
                                                            }
                                                          }}
                                                          className={`${item?.icon} ${
                                                            item?.isActive ||
                                                            (item.id === 0 &&
                                                              faqsFeedbackData[each.id] === 'Helpful') ||
                                                            (item.id === 1 &&
                                                              faqsFeedbackData[each.id] === 'NotHelpful')
                                                              ? styles.Active
                                                              : ''
                                                          } csicon mr-10`}
                                                        />
                                                      ))}
                                                  </div>
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {(!statisticsLoading || apiResultType === 'ANS') && (
                                                <>
                                                  {helpful && helpful[1].isActive && (
                                                    <div>
                                                      <FaqTicketCreate
                                                        issue={each?.issue || ''}
                                                        subIssue={each?.subIssue || ''}
                                                        activeIndex={activeIndex}
                                                        setShowData={setShowData}
                                                        vertical="LISTING"
                                                        category="CS"
                                                        ticketCreator="BUSINESS"
                                                        hideAlert
                                                        hideCrossIcon={false}
                                                        id="leads"
                                                        faqId={each?.pop}
                                                        faqObj={each}
                                                      />
                                                    </div>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                ))}
                            </>
                          ) : (
                            <div className="no-data-div">No Data</div>
                          )}
                          <div className="text_center pt-10 pl-20 pr-20">
                            <button
                              type="button"
                              className={`${styles.viewMore__Btn}`}
                              onClick={async () => {
                                setShowMore((prev) => !prev);
                                if (searchQid && searchQid === '') {
                                  setSelectedQuestionId(null);
                                }
                                await clickTracker(showMore ? 'viewmore' : 'viewless', 'leads_FAQ');
                              }}
                            >
                              {searchQuestion === '' && (showMore ? 'View More' : 'View Less')}
                            </button>
                          </div>
                          <div className="font16 fw700 color111 mb-15 mt-15">
                            Leads Health Check and Competitor View
                          </div>
                          <ul className={`${styles2.TrackCompetitors__itemlist}`}>
                            {healthCheckObj &&
                              healthCheckObj.map((each) => (
                                <li key={each.id} className={`${styles2.TrackCompetitors__item} whitefill_animate`}>
                                  <div className={`${styles2.TrackCompetitors__imgbox}`}>
                                    <img
                                      alt={each.alt}
                                      className={`${styles2.TrackCompetitors__image}`}
                                      src={each.icon}
                                    />
                                  </div>
                                  <div className={`${styles2.TrackCompetitors__textbox} font12 fw500 color111 mt-10`}>
                                    {each?.title || ''}
                                  </div>
                                  <div>
                                    <button
                                      onClick={() => handleHealthCheck(each.id)}
                                      className={`${styles2.HealthCheck__Btn} ${styles2.bluefill_animate} font10 fw-500 colorFFF mt-10`}
                                      type="button"
                                    >
                                      Click Here
                                    </button>
                                  </div>
                                </li>
                              ))}
                          </ul>
                        </>
                      )}
                    </div>
                  </div>{' '}
                </>
              ) : (
                <NoDataView pageName="Leads" />
              )}
            </>
          )}
        </div>
        {faqData && faqData?.length > 0 && contractVal !== 'free' && <Helpfull redirectkey="leads" />}
      </>
    </>
  );
};

export default LeadsFaq;
